import { useQuery } from "@tanstack/react-query";

import { GetScimLogSearchServiceFrontendResponse } from "@performyard/service-contracts";

import { scimLogsQuery } from "../../queries";
import { GetScimLogsParams } from "../../services/defs/internal-api/scim-logs";
import { PYUseQueryOptions } from "../StandardQueryArguments";

export const useScimLogs = (
	{ scimToken, scimId, limit, skip, sort, userEmail, filters }: GetScimLogsParams,
	options?: PYUseQueryOptions<GetScimLogSearchServiceFrontendResponse>
) => {
	const query = useQuery({
		...scimLogsQuery({ scimToken, scimId, limit, skip, sort, userEmail, filters }),
		...options,
	});

	return {
		data: query?.data?.results || [],
		totalCount: query?.data?.total || 0,
		isLoading: query?.isLoading,
	};
};
